import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, trackInitiateCheckout } from './constants';
const noMore = ['No more Sunday nights searching for progressions that actually work', 'No more classes that feel rushed or improvised', 'No more students losing motivation because sessions feel repetitive', 'No more weekends lost planning instead of living', 'No more walking in wishing you had prepared more'];
const included = ['Component 1 — Hip Hop Foundations, Grooves & Body Control (25 classes)', 'Component 2 — Hip Hop Footwork, Steps & Skill Progressions (25 classes)', 'Component 3 — Hip Hop Combinations, Freestyle & Choreography (25 classes)', 'Component 4 — Hip Hop Performance, Class Planning & Instructor System (25 classes)', 'Component 5 — The 5 Strategic Bonuses', 'Component 6 — The Full Instructor Toolkit', '7-day money-back guarantee', 'Immediate access', 'Pay in your local currency', 'PDF format ready to use'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-cream-dark border-t border-line relative overflow-hidden" data-id="element-91" data-mp="2h37yd0dnsp05">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-92" data-mp="2m2b4ko5dl19p">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-93" data-mp="2m4xakjcmb8pt">
          <h2 className="text-3xl md:text-5xl font-serif font-bold uppercase mb-8 leading-tight text-ink" data-id="element-94" data-mp="2v38zmgxu5yg5">
            Next Monday you can keep building your classes from scratch...
            <br data-id="element-95" data-mp="34tu58obxg38k" />
            <span className="brush-accent" data-id="element-96" data-mp="34u3ta6dew0bm">
              Or you can walk into the studio with everything ready — starting
              today.
            </span>
          </h2>

          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-cream-light p-8 rounded-2xl border border-line shadow-sm" data-id="element-97" data-mp="3est79o26t0ml">
            {noMore.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-98" data-mp="1jnk104omporl" data-mpi={i}>
                <span className="text-burgundy mt-1" aria-hidden="true" data-id="element-99" data-mp="1jlz80jhyqdvu">
                  ▸
                </span>
                <span className="text-ink-soft" data-id="element-100" data-mp="1sgexoa016c5r">{item}</span>
              </div>)}
          </div>

          <p className="text-xl text-ink mb-2" data-id="element-101" data-mp="1npeysz7cpk0m">
            Hip Hop Dance Instructor Ready doesn't make you a better instructor.
          </p>
          <p className="text-2xl font-bold text-burgundy mb-6 uppercase font-serif" data-id="element-102" data-mp="22d01is0bdh80">
            You're already a great instructor.
          </p>
          <p className="text-xl text-ink-soft mb-16" data-id="element-103" data-mp="2bf9avejuj4jt">
            What Hip Hop Dance Instructor Ready does is give you the time and
            the tools to make that visible in every single class you teach.
          </p>
        </motion.div>

        <div className="bg-cream-light border-2 border-burgundy/40 rounded-3xl p-8 md:p-12 shadow-[0_16px_40px_rgba(26,26,26,0.1)]" data-id="element-104" data-mp="h209yb5d8rd6">
          <h3 className="text-2xl font-bold uppercase font-serif text-ink mb-6 text-center border-b border-line pb-6" data-id="element-105" data-mp="d29cxpp8xf07">
            Everything included in the complete 6-in-1 system:
          </h3>

          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-106" data-mp="6ze4i25j7jz7">
            {included.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-107" data-mp="3uadtrbqcf8da" data-mpi={i}>
                <CheckIcon size={18} className="text-burgundy shrink-0 mt-0.5" data-id="element-108" data-mp="3u8t0rqjofxhj" />
                <span className="text-sm text-ink-soft" data-id="element-109" data-mp="3fclhqtk0923u">{item}</span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-110" data-mp="3kdraushkurdw">
            <div className="mb-8 p-6 bg-cream rounded-xl border border-gold/70 italic text-ink-soft text-lg" data-id="element-111" data-mp="36cyfy6nd5ua9">
              "The best time to have this 6-in-1 teaching system was before your
              very first hip hop dance class.
              <br data-id="element-112" data-mp="14mmwmg01fra6" />
              <span className="text-burgundy font-bold not-italic" data-id="element-113" data-mp="14m3ht85opj0d">
                The second best time is today.
              </span>
              "
            </div>

            <p className="text-xl font-serif font-bold uppercase text-ink mb-2" data-id="element-114" data-mp="35mhzg5o0ceza">
              📚 Hip Hop Dance Instructor Ready
            </p>
            <p className="text-sm text-ink-muted mb-8" data-id="element-115" data-mp="30mnd8ff6gdkk">
              The complete 6-in-1 hip hop dance teaching system — designed to
              help instructors plan less, teach with confidence, and keep every
              session genuinely fresh.
            </p>

            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackInitiateCheckout} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-116" data-mp="2mq9tezn6802x">
              🟡 GET THE COMPLETE 6-IN-1 TEACHING SYSTEM NOW
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-xs text-ink-muted" data-id="element-117" data-mp="281dqti3vvf9p">
              <span data-id="element-118" data-mp="23ww87m99f80i">✅ 7-day money-back guarantee</span>
              <span data-id="element-119" data-mp="1yzctkl8ngt81">✅ Secure payment</span>
              <span data-id="element-120" data-mp="1z0fhqlel8hk9">✅ Immediate access</span>
              <span data-id="element-121" data-mp="eh2b6uuzb77e">✅ Pay in your local currency</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}